import { useNavigate } from "react-router-dom";
import {useEffect, useState} from "react";
import css from "./Payment-check.module.css"
import Error from "../components/error"

const PaymentCheckPage = () => {
    const navigate = useNavigate();

    const [status, setStatus] = useState("pending");
    const [description, setDescription] = useState("Спасибо! Подписка уже активирована и сохранена в памяти вашего браузера.");
    const [paymentid, setPaymentId] = useState("-");
    const [amount, setAmount] = useState("-");
    const [createdAt, setCreatedAt] = useState("-");
    const [type, setType] = useState("-");
    const [btnText, setBtnText] = useState("-");
    const [error, setError] = useState("");

    document.body.style.zoom = 1


    document.documentElement.style.setProperty("--status-color", `var(--${status})`);
    document.documentElement.style.setProperty("--status-glow", `var(--${status}-glow)`);

    const particles = Array.from({length: 30}, (_, i) => (
        <div className={css.particle} key={i}
             style={{left: Math.random() * 100 + "%", animationDelay: Math.random() * 15 + "s", animationDuration: (Math.random() * 10 + 10) + "s"}}>
        </div>
    ));

    const parceData = async () => {
        const resp = await getPayment()
        if(typeof resp === "string") {
            setError("Похоже, мы не нашли платёж или сервис платежей не отвечает. Пожалуйста, напишите нам в поддержку")
        }

        if(resp.status === "succeeded") {
            setStatus("success")
        } else if (resp.status === "canceled") {
            setStatus("failed")
        } else if (resp.status === "pending") {
            setStatus("pending")
        }

        setPaymentId(resp.payment_id)
        setAmount(resp.amount)
        setCreatedAt(resp.created_at)

        if (resp.type === "sub1") {
            setType("Подписка на 1 день")
        } else if (resp.type === "sub30") {
            setType("Подписка на 1 месяц")
        } else if (resp.type === "sub90") {
            setType("Подписка на 3 месяца")
        } else if (resp.type === "sub180") {
            setType("Подписка на 6 месяцев")
        } else if (resp.type === "sub360") {
            setType("Подписка на 1 год")
        } else if (resp.type === "donate") {
            setType("Поддержка разработчика")
        }
    }

    const btnClick = () => {
        if(status === "success") {
            navigate("/sub")
        } else if (status === "failed") {
            navigate("/")
        } else if (status === "pending") {
            parceData()
        }
    }



    useEffect(() => {
        if(!localStorage.getItem("payment_id")) {
            navigate("/")
        } else {
            setPaymentId(localStorage.getItem("payment_id"))
        }
        let timer = null
        if(status === "success") {
            localStorage.removeItem("payment_id")
            setBtnText("Перейти к подписке")
        } else if(status === "pending") {
            setTimeout(parceData, 5000)
            setBtnText("Обновить статус")

        } else if(status === "failed") {
            setBtnText("Попробовать снова")
        }
        return clearTimeout(timer)
    }, [status])


    if (error) {
        return <Error title="Ошибка" text={error} />;
    }

    return (
        <>
            <div className={css.bgGrid}></div>
            <div className={`${css.bgGlow} ${css.bgGlow1}`}></div>
            <div className={`${css.bgGlow} ${css.bgGlow2}`}></div>
            <div className={css.particles} id="particles">
                {particles}
            </div>

            <div className={css.wrap}>



                <div className={css.card}>

                    <div className={css.state + (status === 'success'? ` ${css.active}` : '')} data-state="success">
                        <div className={`${css.statusIcon} ${css.success}`}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" opacity="0.2"/>
                                <path className="check-path" d="M7 12.5l3.5 3.5L17 9"/>
                            </svg>
                        </div>
                        <h1 className={css.statusTitle}>Оплата прошла успешно</h1>
                        <p className={css.statusDesc}>{description}</p>
                    </div>

                    <div className={css.state + (status === 'pending'? ` ${css.active}` : '')} data-state="pending">
                        <div className={`${css.statusIcon} ${css.pending}`}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" opacity="0.2"/>
                                <path d="M12 6v6l4 2"/>
                            </svg>
                        </div>
                        <h1 className={css.statusTitle}>Платёж в обработке</h1>
                        <p className={css.statusDesc}>Мы получили ваш платёж и ожидаем подтверждения от банка. Это займёт
                            несколько минут.</p>
                    </div>

                    <div className={css.state + (status === 'failed'? ` ${css.active}` : '')} data-state="failed">
                        <div className={`${css.statusIcon} ${css.failed}`}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" opacity="0.2"/>
                                <path d="M15 9l-6 6M9 9l6 6"/>
                            </svg>
                        </div>
                        <h1 className={css.statusTitle}>Платёж отклонён</h1>
                        <p className={css.statusDesc}>К сожалению, оплата не прошла. Средства не были списаны. Попробуйте
                            ещё раз или выберите другой способ оплаты.</p>
                    </div>

                    <div className={css.txDetails}>
                        <div className={css.txRow}>
          <span className={css.txLabel}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
            ID
          </span>
                            <span className={css.txValue}>{paymentid}</span>
                        </div>
                        <div className={css.txRow}>
          <span className={css.txLabel}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <line x1="12" y1="1" x2="12" y2="23"/>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
            Сумма
          </span>
                            <span className={`${css.txValue} ${css.amount}`}>{amount} ₽</span>
                        </div>
                        <div className={css.txRow}>
          <span className={css.txLabel}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            Время
          </span>
                            <span className={css.txValue}>{createdAt}</span>
                        </div>
                        <div className={css.txRow}>
          <span className={css.txLabel}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="2"/>
              <line x1="2" y1="10" x2="22" y2="10"/>
            </svg>
            Тип транзакции
          </span>
                            <span className={css.txValue}>{type}</span>
                        </div>
                    </div>

                    <div className={css.actions}>
                        <button className={`${css.btn} ${css.btnPrimary}`} id="primaryBtn" onClick={()=>btnClick()}>
                            <span id="primaryText">{btnText}</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"/>
                                <polyline points="12 5 19 12 12 19"/>
                            </svg>
                        </button>
                        <a href="#" className={`${css.btn} ${css.btnGhost}`}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
                                <path d="M21 19a2 2 0 0 1-2 2h-1v-6h3v4zM3 19a2 2 0 0 0 2 2h1v-6H3v4z"/>
                            </svg>
                            Техническая поддержка
                        </a>
                    </div>

                </div>

            </div>
        </>
    );
};

async function getPayment() {
    try {
        const base_url = "https://api.bezopas.net/pay/yookassa/payments?";

        const email = localStorage.getItem("email");
        const paymentid = localStorage.getItem("payment_id");

        const params = new URLSearchParams();
        params.append("email", email);
        params.append("payment_id", paymentid);
        const full_url = base_url + params.toString();

        const response = await fetch(full_url, {method: "GET"});
        if (response.status === 404) return "Not found";
        if (response.status === 400) return "Bad Request";
        if (!response.ok) return "Server Error";
        return response.json();
    } catch {
        return "Server Error";
    }
}


export default PaymentCheckPage;